import * as React from "react";

export type FormItemContextValue = {
  id: string;
  /**
   * The id the control actually renders with when a call site passes its own
   * (`<FormControl><Input id="client-notes" /></FormControl>`). FormLabel
   * points `htmlFor` at it so the label still names the control.
   */
  controlId?: string;
  setControlId?: (id: string | undefined) => void;
};

export const FormItemContext = React.createContext<FormItemContextValue>(
  {} as FormItemContextValue,
);
